<div class="skill-range anim-item is-scroll" [class.no-shadow]="noShadow"
  [class.is-hidden]="!control.get('name').value.toLowerCase().includes(searchTerm)">

  <div class="skill-range__header">
    <div class="skill-header-row">
      <h3>{{ control.get('name').value }}</h3>
       <div class="skill-exp-row">
      <div class="is-exp-dots">
        <span *ngFor="let e of [].constructor(5); let i = index"
          [class.is-active]="i < control.get('experience').value">
        </span>
      </div>
    </div>
    </div>
    <p>{{ 'SkillRange.ExperienceDescription' | translate }}</p>
   
  </div>

  <div class="skill-range__slider">
    <div class="range-slider" [class.tooltip]="control.get('experience').value === 4">
      <input type="range" min="0"
        [max]="control.get('experience').value === 5 ? 5 : (tradeOffMax !== tradeOffSelected) || (tradeOffMax === tradeOffSelected && tradeOffMax <= 3) ? 5 : 4"
        [style.width]="(control.get('experience').value === 5 ? 5 :(tradeOffMax !== tradeOffSelected) || (tradeOffMax === tradeOffSelected && tradeOffMax <= 3) ? 5 : 4) * 20 + '%'"
        [formControl]="$any(control.get('experience'))" (input)="rangeChanged()">
    </div>
    <div class="tooltiptext"
      *ngIf="control.get('experience').value === 4 && tradeOffMax === tradeOffSelected && tradeOffMax > 3 && !selectedBranch">
      {{ 'SkillRange.TradeOffTooltipNoBranch' | translate: { tradeOffMax: tradeOffMax } }}
    </div>
    <div class="tooltiptext"
      *ngIf="control.get('experience').value === 4 && tradeOffMax === tradeOffSelected && tradeOffMax > 3 && selectedBranch">
      {{ 'SkillRange.TradeOffTooltipWithBranch' | translate: { tradeOffMax: tradeOffMax, selectedBranch: selectedBranch } }}
    </div>
    <div class="skill-range__slider__level">
      <div>{{ 'SkillRange.NoExperience' | translate }}</div>
      <div>{{ 'SkillRange.Senior' | translate }}</div>
    </div>
  </div>

  <ng-container *ngIf="(role$ | async) !== USER_ROLES.talent && (onboardingRole$ | async) !== USER_ROLES.talent">
    <div class="skill-range__must-have">
      <div class="skill-range__slider">
        <div class="skill-header-row">
          <h3>{{ 'SkillRange.LevelOfImportance' | translate }}</h3>
                  <div class="tooltip">
          {{ getRequirementLevelLabel(control.get('requirementLevel').value) }}
          <span class="tooltiptext">
            {{ getRequirementLevelDescription(control.get('requirementLevel').value) }}
          </span>
        </div>
        </div>

        <p>
          {{ 'SkillRange.ImportanceDescription' | translate }}
        </p>
        <div class="range-slider" [class.tooltip]="control.get('requirementLevel').value === 4">
          <input type="range" min="0" [max]="4"
            [style.width]="(control.get('requirementLevel').value === 5 ? 5 :(tradeOffMax !== tradeOffSelected) || (tradeOffMax === tradeOffSelected && tradeOffMax <= 3) ? 5 : 4) * 20 + '%'"
            [formControl]="$any(control.get('requirementLevel'))" (input)="requirmentLevelRangeChanged()">
        </div>
        <!-- Show the label under the slider -->
        <div class="skill-range__slider__level" (mouseenter)="showToolTip = true" (mouseleave)="showToolTip = false"
          style="position: relative;">
          <div>{{ 'Common.LowPriority' | translate }}</div>

          <div>{{ 'Common.MustHave' | translate }}</div>
        </div>
      </div>
      
      <!-- IsRequired Checkbox -->
      <div class="skill-range__is-required" *ngIf="control.get('requirementLevel').value === 4">
        <a-checkbox 
          [label]="'SkillRange.ExcludeCandidatesLackingSkill' | translate" 
          [control]="$any(control.get('isRequired'))"
          (onChanged)="isRequiredChanged($event)">
        </a-checkbox>
      </div>
    </div>
  </ng-container>


  <div class="skill-range__years">
    <div class="skill-range__years__title">{{ 'SkillRange.YearsOfExperience' | translate }}</div>
    <div class="skill-range__years__optional"><span>{{ 'Common.Optional' | translate }}</span></div>
    <div class="skill-range__years__text">
      <ng-container *ngIf="(role$ | async) !== USER_ROLES.talent">
        {{ 'SkillRange.YearsDescriptionHM' | translate }}
      </ng-container>
      <ng-container *ngIf="(role$ | async) == USER_ROLES.talent">
        {{ 'SkillRange.YearsDescriptionTalent' | translate }}
      </ng-container>
    </div>
    <div class="skill-range__years__counter">
      <div class="is-btn is-btn__outfill" (click)="setYears(-1)" [class.is-disabled]="!control.get('years').value">
        &minus;
      </div>
      <div class="skill-range__years__counter__number">
        {{ control.get('years').value }}
      </div>
      <div class="is-btn is-btn__outfill" (click)="setYears(1)"
        [class.is-disabled]="!control.get('experience').value || control.get('years').value === 20">
        &plus;
      </div>
    </div>
  </div>

  <div class="assessment-check__years" skill-range__years
    *ngIf="(role$ | async) === USER_ROLES.hm || (role$ | async) === USER_ROLES.admin">
    <!-- HM Role View -->
    <ng-container *ngIf="(role$ | async) === USER_ROLES.hm">
      <div class="assessment-check__years__title" [class.is-loading]="!assessmentChecked">
        <span class="main-loader" *ngIf="!assessmentChecked"></span>
        {{
          assessmentChecked
            ? (assessmentAvailable ? ('SkillRange.AssessmentAvailable' | translate) : ('SkillRange.AssessmentNotAvailable' | translate))
            : ('SkillRange.CheckingAssessmentAvailability' | translate)
        }}
      </div>
      <div class="assessment-check__years__text" *ngIf="assessmentChecked && assessmentAvailable">
        <a-checkbox class="assessment-check__require-assessment-checkbox" [label]="'SkillRange.RequireAssessment' | translate" (onChanged)="optForAssessment($event)"
        [control]="$any(control.get('isValidationRequired'))">
        </a-checkbox>
      </div>
    </ng-container>

    <!-- Admin Role View -->
    <ng-container *ngIf="(role$ | async) === USER_ROLES.admin">
      <div class="assessment-check__years__title" skill-range__years__title>
        <span class="assessment-note" *ngIf="assessmentAvailable">
          {{ 'SkillRange.AssessmentAvailableAdmin' | translate }}
        </span>
        <span class="assessment-note" *ngIf="!assessmentAvailable">
          {{ 'SkillRange.AssessmentNotAvailableAdmin' | translate }}
        </span>
      </div>
      <div class="assessment-check__years__btn" skill-range__years__btn>
        <div class="is-btn is-btn__outfill" (click)="openAssessmentPopup()">
          <i *ngIf="!assessmentAvailable" class="app-ico app-ico__plus"></i>
          {{ assessmentAvailable ? ('Common.Change' | translate) : ('Common.Add' | translate) }}
        </div>
      </div>
    </ng-container>
  </div>

</div>

<app-add-change-assessment *ngIf="showAssessmentModal" [skillName]="skillName" [jobTitle]="jobTitle"
  [skillAssessmentId]="assessmentId" [Level]="seniority" (close)="closeAssessmentPopup($event)">
</app-add-change-assessment>